import * as React from 'react';

const SvgUniqueErgo4Light = (props) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 140 151"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M63.343 26a44.072 44.072 0 0 1 32.623 8.35 44 44 0 0 1 16.27 46.085 43.948 43.948 0 0 1-7.414 15.49 44 44 0 0 1-28.994 17.178 44.07 44.07 0 0 1-32.655-8.33 44 44 0 0 1-17.2-28.959 44.013 44.013 0 0 1 8.366-32.635 44.084 44.084 0 0 1 29.004-17.178Z"
      fill="url(#unique-ergo-4-light_svg__a)"
    />
    <path
      d="M69.643 1a68.706 68.706 0 0 0-48.54 20.11A68.59 68.59 0 0 0 1 69.618a68.525 68.525 0 0 0 10.303 36.094 68.6 68.6 0 0 0 27.777 25.266c7.35 3.68 14.58 1.773 17.554-4.287 3.598-7.208 3.497-16.88-4.325-20.611a40.383 40.383 0 0 1-16.814-14.895 40.336 40.336 0 0 1-6.247-21.567 40.314 40.314 0 0 1 11.826-28.544 40.382 40.382 0 0 1 28.569-11.816 40.375 40.375 0 0 1 28.545 11.824 40.301 40.301 0 0 1 11.799 28.536 40.336 40.336 0 0 1-6.247 21.567 40.386 40.386 0 0 1-16.814 14.895c-7.823 3.714-7.873 13.403-4.342 20.611 3.04 6.06 10.255 7.967 17.621 4.287a68.64 68.64 0 0 0 27.734-25.282 68.567 68.567 0 0 0 10.279-36.078 68.514 68.514 0 0 0-20.06-48.504 68.607 68.607 0 0 0-22.255-14.88A68.659 68.659 0 0 0 69.643 1v0Z"
      stroke="#121212"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M88.515 20.311a1.283 1.283 0 0 1-.76-1.688 1.351 1.351 0 0 1 1.69-.742 55.744 55.744 0 0 1 25.764 20.256 54.803 54.803 0 0 1 9.765 31.482 54.674 54.674 0 0 1-9.681 31.245 55.576 55.576 0 0 1-25.764 20.257 1.373 1.373 0 0 1-1.69-.743 1.316 1.316 0 0 1 .76-1.688 52.912 52.912 0 0 0 24.549-19.328 52.557 52.557 0 0 0 9.241-29.743 52.634 52.634 0 0 0-9.241-29.895 53.346 53.346 0 0 0-24.633-19.412Zm-37.793 98.463a1.314 1.314 0 0 1 .724.69 1.3 1.3 0 0 1 .02.998 1.278 1.278 0 0 1-1.187.838 1.291 1.291 0 0 1-.503-.095 55.748 55.748 0 0 1-25.815-20.256 54.948 54.948 0 0 1-9.63-31.33 55.048 55.048 0 0 1 9.698-31.28 55.575 55.575 0 0 1 25.815-20.256 1.282 1.282 0 0 1 1.69.743 1.247 1.247 0 0 1-.744 1.688A52.872 52.872 0 0 0 26.19 39.926 52.164 52.164 0 0 0 16.85 69.62a52.08 52.08 0 0 0 9.275 29.794 52.364 52.364 0 0 0 24.598 19.361Z"
      fill="url(#unique-ergo-4-light_svg__b)"
    />
    <path
      d="M69.644 76.877a7.312 7.312 0 0 0 7.315-7.309 7.312 7.312 0 0 0-7.315-7.31 7.312 7.312 0 0 0-7.315 7.31 7.312 7.312 0 0 0 7.315 7.31Z"
      fill="#121212"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M68.32 69.62a1.333 1.333 0 0 1 1.319-1.3 1.285 1.285 0 0 1 1.267 1.3v80.079a1.284 1.284 0 0 1-1.25 1.3 1.335 1.335 0 0 1-1.318-1.3l-.017-80.08Z"
      fill="url(#unique-ergo-4-light_svg__c)"
    />
    <defs>
      <linearGradient
        id="unique-ergo-4-light_svg__b"
        x1={46.8}
        y1={31.639}
        x2={69.55}
        y2={131.962}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={0.51} stopColor="#FF5E18" />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="unique-ergo-4-light_svg__c"
        x1={62.85}
        y1={142.204}
        x2={62.007}
        y2={72.994}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0} />
        <stop offset={0.681} stopColor="#121212" />
        <stop offset={1} stopColor="#121212" />
      </linearGradient>
      <radialGradient
        id="unique-ergo-4-light_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(0 43.9948 -44.0349 0 69.565 69.555)"
      >
        <stop stopColor="#FF5E18" />
        <stop offset={0.443} stopColor="#FF5E18" />
        <stop offset={0.964} stopColor="#FF5E18" stopOpacity={0} />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgUniqueErgo4Light;
